"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Button_1 = __importDefault(require("../../../../../../../../components/Button"));
var Icon_1 = __importDefault(require("../../../../../../../../components/Icon"));
var react_i18next_1 = require("react-i18next");
var react_redux_1 = require("react-redux");
var schemaSlice_1 = require("../../../../../../../../features/post/schemaSlice");
var styles_module_scss_1 = __importDefault(require("../../styles.module.scss"));
var FormHeader = function (_a) {
    var index = _a.index, duplicateApartment = _a.duplicateApartment, removeApartment = _a.removeApartment, entityId = _a.entityId, canRemove = _a.canRemove;
    var t = react_i18next_1.useTranslation('common').t;
    var currentPropertyData = react_redux_1.useSelector(schemaSlice_1.selectCurrentPropertyType);
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.nested_section_header },
        react_1.default.createElement("h4", { className: styles_module_scss_1.default.nested_section_title }, t('POST_SCREEN.SECTION_ITEMS.' +
            currentPropertyData.toUpperCase()) + " " + (index + 1)),
        react_1.default.createElement("span", null,
            react_1.default.createElement(Button_1.default, { variant: "text", className: styles_module_scss_1.default.duplicate_btn, onClick: function (e) {
                    e.stopPropagation();
                    duplicateApartment(entityId);
                } },
                react_1.default.createElement(Icon_1.default, { semanticName: "copy" }),
                react_1.default.createElement("span", null, t('POST_SCREEN.DUPLICATE_APARTMENT'))),
            canRemove && (react_1.default.createElement(Button_1.default, { variant: "text", className: styles_module_scss_1.default.delete_btn, onClick: function (e) {
                    e.stopPropagation();
                    removeApartment(entityId);
                } },
                react_1.default.createElement(Icon_1.default, { semanticName: "trash alternate outline" }))))));
};
exports.default = react_1.memo(FormHeader);
